<template>
  <div class="msg-box">
    <p>{{ msgText }}</p>
  </div>
</template>

<script>
export default {
  name: "MsgPop",
  props: {
    msg: String
  },
  data: function() {
    return {
      msgText: "请复制链接使用微信浏览器打开链接"
    };
  }
};
</script>

<style scoped>
.msg-box {
  /* display: none; */
  width: 100%;
  height: 100%;
  position: fixed;
  background: rgba(0, 0, 0, 0.85);
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1001;
}
.msg-box p {
  margin-top: 35%;
  color: #fff;
  text-align: center;
  font-size: 0.32rem;
  font-weight: 500;
}
</style>
